import jwt_decode from "jwt-decode";
const tokenName = 'token';
const BEARER = 'Bearer';

export const getRole = (token = getToken()) => {
    if(!token) return null

    const replaceStr = `${BEARER} `
    const {role} = jwt_decode(token.replace(new RegExp(replaceStr, "g"), ''), { header: true });

    return role
}

export const getToken = () => {
    // return apiKeyAdmin;

    const data = localStorage.getItem(tokenName);

    if(!data) return ;

    const {token} = JSON.parse(data)

    return `${BEARER} ${token}`;
}

export const setToken = (token) => {
    if (token && typeof token === 'object') {
        return localStorage.setItem(tokenName, JSON.stringify(token));
    };
};

export const clearToken = () => {
    localStorage.removeItem(tokenName);
    window.location.reload();

    return false;
};
